import React from "react";
import EditDetailsProductStockOut from "../../../components/screen/inventory/productHabis/EditDetailProductStockOut";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import HOC from "../../../components/HOC";

const EditDetailsProductHabisPage = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header={
          "Update Information Inventory " +
          (isWarehouse ? "Central Warehouse" : "")
        }
        mainComponent={<EditDetailsProductStockOut isWarehouse={isWarehouse} />}
        pageRole={isWarehouse ? 27 : 4}
      />
    </div>
  );
};

export default HOC(EditDetailsProductHabisPage);
